.ux-spinner-overlay {
  display: block;
  height: 100%;
  left: 0;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: $z-index-spinner-overlay;

  &--closed {
    display: none;
  }

  &__backdrop {
    background: rgb(0 0 0 / 30%);
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;

    .ux-spinner-overlay--opening & {
      opacity: 0;
    }

    .ux-spinner-overlay--opened & {
      opacity: 1;
      transition: opacity $animationSpeed-fast ease-out;
    }

    .ux-spinner-overlay--closing & {
      opacity: 0;
      transition: opacity $animationSpeed-fast ease-out;
    }

    .ux-spinner-overlay--closed & {
      opacity: 0;
    }
  }
}

ux-loader {
  margin: 0;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}
